import { VerticalNavigationTabs } from "features/shared/components/VerticalNavigationTabs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "utils/styling";

import type { ExecutionTab } from "../model/constants";

import { EXECUTION_TAB_IDS } from "../model/constants";

type ExecutionNavMenuProps = {
  activeTab: ExecutionTab;
  className?: string;
  setActiveTab: (tab: ExecutionTab) => void;
};

const isExecutionTab = (value: string): value is ExecutionTab => EXECUTION_TAB_IDS.some((tabId) => tabId === value);

export const ExecutionNavMenu = ({ activeTab, className, setActiveTab }: ExecutionNavMenuProps) => {
  const { t } = useTranslation();
  const groups = useMemo(
    () => [
      {
        items: EXECUTION_TAB_IDS.map((tabId) => ({
          id: tabId,
          label: t(`Execution.tabs.${tabId}`),
        })),
      },
    ],
    [t]
  );

  return (
    <VerticalNavigationTabs
      activeTab={activeTab}
      className={cn("flex flex-col px-1 py-6", className)}
      groups={groups}
      setActiveTab={(tabId) => {
        if (isExecutionTab(tabId)) setActiveTab(tabId);
      }}
    />
  );
};
